const USER_NAMESPACE = '@baps-oj/user';
const USER_DATA = `${USER_NAMESPACE}/info`;
const USER_TOKEN = `${USER_NAMESPACE}/token`;

export { USER_NAMESPACE, USER_DATA, USER_TOKEN };
